module.exports = __webpack_public_path__ + "img/zhexian.dbc05780.png";